exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".block{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-8d6801b0!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/views/user/ConfigAuthority.vue
// module id = 606
// module chunks = 2